import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../constants/table";
import ReactPaginate from "react-paginate";
import IconEmbeddedButton from "../../ui/IconEmbeddedButton";
import { CSVLink } from "react-csv";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { getCurrentDateTime } from "../../../helpers/date";

const itemsPerPage = DEFAULT_ITEMS_PER_PAGE;

const DataTable = ({ tableHeadings, tableData, title = null }: any) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(tableData.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentData = tableData.slice(offset, offset + itemsPerPage);

  useEffect(() => {
    setCurrentPage(0);
  }, [tableHeadings, tableData]);

  const getNestedValue = (obj: any, path: string) => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  return (
    <>
      <Row>
        <Col>
          <h5 className="app-header-text">{title}</h5>
        </Col>
        <Col className="text-end">
          {tableData && (
            <CSVLink
              id="download-goals-button"
              data={tableData}
              headers={tableHeadings}
              filename={`${title}${getCurrentDateTime()}.csv`}
              style={{ display: "inline-block" }}
              target="_blank"
            >
              <IconEmbeddedButton tooltipText="Data Export" icon={faDownload} />
            </CSVLink>
          )}
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xs={12}>
          <div style={{ overflowX: "auto" }}>
            <Table striped>
              <thead>
                <tr>{tableHeadings?.map((heading: any) => !heading?.hide && <th key={heading?.key}>{heading?.label}</th>)}</tr>
              </thead>
              <tbody>
                {currentData?.map((row: any, rowIndex: number) => (
                  <tr key={rowIndex}>
                    {tableHeadings?.map(
                      (heading: any) =>
                        !heading?.hide && (
                          <td className="text-capitalize" key={heading?.key}>
                            {getNestedValue(row, heading?.key)}
                          </td>
                        ),
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            {pageCount > 1 && (
              <div id="pagination" style={{ position: "relative", zIndex: 0 }}>
                <ReactPaginate
                  previousLabel={"← Previous"}
                  nextLabel={"Next →"}
                  pageCount={pageCount}
                  onPageChange={(event: { selected: number }) => setCurrentPage(event.selected)}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={currentPage}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DataTable;
